import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client';
const CRM_BASE_URL = 'inbounddb-objects/v1';
const CRM_MANAGER_BASE_URL = 'multi-account/crm-manager/v1';
export const GET_CONTACT_DETAILS = registerQuery({
  fieldName: 'contactDetails',
  args: ['contactId'],
  fetcher({
    contactId
  }) {
    return http.get(`${CRM_BASE_URL}/crm-objects/0-1/${contactId}?includeAllValues=true`);
  }
});
export const GET_CONTACT_RELATED_ACCOUNTS = registerQuery({
  fieldName: 'contactRelatedAccounts',
  args: ['contactId'],
  fetcher({
    contactId
  }) {
    return http.get(`${CRM_MANAGER_BASE_URL}/contact-share/${contactId}/related-accounts`);
  }
});
export const GET_COMPANY_RELATED_ACCOUNTS = registerQuery({
  fieldName: 'companyRelatedAccounts',
  args: ['companyId'],
  fetcher({
    companyId
  }) {
    return http.get(`${CRM_MANAGER_BASE_URL}/contact-share/${companyId}/related-accounts`);
  }
});
export const GET_CONTACT_TIMELINE = registerQuery({
  fieldName: 'contactTimeline',
  args: ['targetPortalId', 'contactId', 'activityTypes'],
  fetcher({
    targetPortalId,
    contactId,
    activityTypes
  }) {
    return http.get(`${CRM_MANAGER_BASE_URL}/contact-timeline?targetPortalId=${targetPortalId}&contactId=${contactId}${activityTypes.map(activity => `&types=${activity}`).join('')}`);
  }
});
export const GET_EMAIL_DETAILS = registerQuery({
  fieldName: 'emailDetails',
  args: ['targetPortalId', 'contactId', 'trackerKeys'],
  fetcher({
    targetPortalId,
    contactId,
    trackerKeys
  }) {
    return http.post(`${CRM_MANAGER_BASE_URL}/contact-timeline/email-details`, {
      data: {
        targetPortalId,
        contactId,
        trackerKeys
      }
    });
  }
});
export const GET_MEETING_DETAILS = registerQuery({
  fieldName: 'meetingDetails',
  args: ['targetPortalId', 'contactId', 'meetingId'],
  fetcher({
    targetPortalId,
    contactId,
    meetingId
  }) {
    return http.get(`${CRM_MANAGER_BASE_URL}/contact-timeline/meeting-details?targetPortalId=${targetPortalId}&contactId=${contactId}&meetingId=${meetingId}`);
  }
});
export const GET_DEALS = registerQuery({
  fieldName: 'deals',
  args: ['targetPortalId', 'contactId'],
  fetcher({
    targetPortalId,
    contactId
  }) {
    return http.get(`${CRM_MANAGER_BASE_URL}/associated-objects/deals?targetPortalId=${targetPortalId}&contactId=${contactId}`);
  }
});
export const GET_IS_CONNECTED_CONTACT = registerQuery({
  fieldName: 'isConnectedContact',
  args: ['contactId'],
  fetcher({
    contactId
  }) {
    return http.get(`${CRM_MANAGER_BASE_URL}/contact-share/${contactId}/is-connected-contact`);
  }
});